import EditorModel from '../../coreEditor/EditorModel'
import { EditorEntityType } from '../../coreEditor/EditorController'

export default class NotesEditorModel extends EditorModel {
  constructor(config) {
    super({ ...config, entityType: EditorEntityType.Note })
    this.setEntityId(config.noteId)
  }
}
